<template>
  <div class="greybar" v-on:mouseenter="doit = true" v-on:mouseleave="doit = false">
      <transitionable-panel :activated="doit" :updateData="artist" :collapse="collapse">
        <div class="clipped artist-name">
          <ix-router-link :to="portfolioUrl">{{ artist.formatted_name }}</ix-router-link>
        </div>
        <div class="tag-panel" v-if="!playButton">
          <gallery-tag v-for="gallery in galleries" :key="gallery.gallery_id" :galleryId="gallery.gallery_id" />
          <div class="tag region" v-on:click.stop="changeRegion">{{ artist.region }}</div>
        </div>
        <div class='tag-panel' v-if="playButton">
          <small-button v-on:click="$emit('view', likeImageId)">{{ $nippets.play }}</small-button>
        </div>
        <div class="likebox-holder"><like-box :imageId="likeImageId" /></div>
      </transitionable-panel>
    </div>
</template>

<script>
import GalleryTag from '@/components/buttons/GalleryTag.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'
import TransitionablePanel from '@/components/widgets/TransitionablePanel.vue'

export default {
  components: {
    GalleryTag,
    LikeBox,
    TransitionablePanel
  },
  props: {
    artist: {
      type: Object,
      default: function () { return {} }
    },
    likeImageId: Number,
    playButton: Boolean,
    collapse: Boolean,
    animation: Boolean
  },
  computed: {
    portfolioUrl () {
      if(!this.artist) return ''
      if(this.animation) return '/animators/' + this.artist.portfolio_url
      else return '/artists/' + this.artist.portfolio_url
    }
  },
  data () {
    return {
      doit: false,
      galleries: []
    }
  },
  created: function () {
    this.loadGalleries()
  },
  methods: {
    loadAll: async function () {
      if(!this.playButton) {
        await this.loadGalleries()
      }
      
    },
    loadGalleries: async function () {
      if(this.artist && (!this.playButton)) {
        await this.$store.dispatch('fetchGalleries')
        let gals = this.$store.getters.artistGalleries(this.artist).filter(el => el.animation === this.animation)
        if(gals.length > 6) {
          gals = this.$k.shuffleCopyArray(gals)
          this.galleries = gals.slice(0, 6)
        }
        else {
          this.galleries = gals
        }
      }
    },
    changeRegion: function () {
      this.$store.commit('setAzLocation', this.artist.region)
    }
  },
  watch: {
    artist: function () {
      if(this.artist.artist_id) {
        this.loadGalleries()
      }
      
    }
  }
}
</script>
<style scoped>
.tag-panel{
  display:none;
  padding-top:8px;
}
</style>
<style>
.greybar:hover .clipped{
  white-space:normal;
}

.clipped {
  overflow: hidden;
  white-space: nowrap;
  transition:all 0.2s ease;
  text-overflow: ellipsis; 
}
</style>
